import React from "react"
import "./index.scss"
import cx from "classnames"
import Text from "components/text"

import { formatErrorMessage } from "helpers/util"

const FormInput = ({
  withIcon,
  label,
  placeholder,
  labelFor,
  success,
  handleChange,
  value,
  name,
  error,
  horizontal,
  type = "text",
  required,
  disabled = false,
  inputRef,
  ...props
}) => {
  let hasError = Boolean(error)
  return (
    <div
      className={`form-input ${horizontal ? "-horizontal" : "-vertical"} 
      ${withIcon ? "-with-icon" : ""}`}
    >
      {label && <Text type="label" text={label + (required ? " *" : "")} />}
      <input
        className={`${success ? "form-success" : ""}`}
        type={type}
        name={name}
        value={value || ""}
        onChange={handleChange}
        disabled={disabled}
        placeholder={placeholder}
        ref={inputRef}
        {...props}
      />

      {withIcon && (
        <span className={cx("form-icon", success)}>
          <i
            className={cx(
              success
                ? "fas fa-check success"
                : "fas fa-exclamation-circle warning"
            )}
          ></i>
        </span>
      )}
      {labelFor && <p className="form-hint">{labelFor}</p>}
      {hasError && (
        <p className="error-message">{`* ${formatErrorMessage(error)}`}</p>
      )}
    </div>
  )
}

export default FormInput
